import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import OurBlogComponent from '../../components/OurBlog';

export default function OurBlog() {
  return (
    <>
      <Navbar />
      <OurBlogComponent />
      <Footer />
    </>
  );
}
